import classNames from "classnames";

function ModalCloseButton({ onClick, className }) {
  return (
    <button
      className={classNames(
        "h-9 w-max flex flex-row items-center cursor-pointer rounded-sm modal-close-button-background",
        className
      )}
      onClick={onClick}
    >
      <span className="w-full h-full flex flex-row items-center px-1 select-none font-extrabold">
        CLOSE (Esc)
      </span>
    </button>
  );
}

export default ModalCloseButton;
